import InsertLink from '@mui/icons-material/InsertLink';
import { ToggleButton, ToggleButtonProps } from '@mui/material';
import { useTranslate } from 'ra-core';
import { useEditorSelection, useTiptapEditor } from 'ra-input-rich-text';
import { useState } from 'react';
import { LinkInputModal } from '../LinkInput';

const LinkLinkButton = (props: Omit<ToggleButtonProps, 'value'>) => {
  const editor = useTiptapEditor();
  const translate = useTranslate();
  const currentTextSelection = useEditorSelection();
  const [showDialog, setShowDialog] = useState(false);

  const label = translate('ra.tiptap.link', {
    _: 'Add a link',
  });

  const handleClick = () => {
    if (!(editor.can() as any).setLink({ href: '' })) {
      return;
    }

    setShowDialog(true);
  };

  const handleSelectClick = (selection: any) => {
    console.log('handleSelectClick', selection);
    setShowDialog(false);
    if (1 === selection.length) {
      (editor
        .chain()
        .focus()
        .extendMarkRange('link') as any)
        .setLink({ href: selection[0].url_path })
        .run();
    }
  }

  const handleCloseClick = () => {
    console.log('handleCloseClick');
    setShowDialog(false)
  }

  return (
    <>
      <ToggleButton
        aria-label={label}
        title={label}
        {...props}
        disabled={!editor?.isEditable || !currentTextSelection}
        value="link"
        onClick={handleClick}
        selected={editor && editor.isActive('link')}
      >
        <InsertLink fontSize="inherit" />
      </ToggleButton>
      <LinkInputModal showDialog={showDialog} handleCloseClick={handleCloseClick} handleSelectClick={handleSelectClick} />
    </>
  );
};

export default LinkLinkButton;
